import {
  Component,
  Input,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import {
  DateFilters,
  Proveedor,
  CesionarioSummaries,
} from '../../interface/data.interface';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { ChartComponent } from 'ng-apexcharts';
import { ChartOptions } from '../factoring-monthly-amount/factoring-monthly-amount.component';


@Component({
  selector: 'app-factoring-factorizations',
  templateUrl: './factoring-factorizations.component.html',
  styleUrls: ['./factoring-factorizations.component.scss'],
})
export class FactoringFactorizationsComponent {
  @Input() recieveFilterDate: DateFilters;
  @Input() cesionarioSummaries: CesionarioSummaries;
  @Input() recieveFilterName: CesionarioSummaries;
  @ViewChild('chart') chart: ChartComponent = Object.create(null);
  @ViewChild(MatSort, { static: true }) sort: MatSort = Object.create(null);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator =
    Object.create(null);
  public dataSource!: MatTableDataSource<CesionarioSummaries>;
  public gredientChartOptions: Partial<ChartOptions> | any;
  @Input() booleanFlagCesionario: boolean;

  public dateElement: Proveedor[] = [];
  displayedColumns: string[] = ['name', 'rut', 'invoiceAmount', 'docs'];

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {

    const boardDeals: Array<CesionarioSummaries> =
    changes['cesionarioSummaries']?.currentValue;

    // if (changes['booleanFlagCesionario']) {
    //   const newBoolean = changes['booleanFlagCesionario']?.currentValue;
    //   if (!newBoolean) {
    //     this.booleanFlagCesionario = true;
    //   }
    // }

    if (changes['cesionarioSummaries']) {
  
      this.dataSource = new MatTableDataSource<CesionarioSummaries>(boardDeals);
      this.setDataSource(boardDeals);
      var newDeptors = changes['cesionarioSummaries'].currentValue;
      const length : number = newDeptors?.length;
      this.setDataSource(newDeptors);
      // if (length > 0) {
      //   this.booleanFlagCesionario = false;
      // }
    }

    if (changes['recieveFilterName']) {
      const newDeptors = changes['recieveFilterName'].currentValue;
      this.setDataSource(newDeptors);
      const length = newDeptors?.length;

      // if (length > 0) {
      //   this.booleanFlagCesionario = false;
      // }
    }
  }

  private setDataSource(dataSource: Array<CesionarioSummaries>) {
    this.dataSource = new MatTableDataSource<CesionarioSummaries>(dataSource);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
}
